import { render, staticRenderFns } from "./GraduationApprovalsSection.vue?vue&type=template&id=2f809f58&scoped=true"
import script from "./GraduationApprovalsSection.vue?vue&type=script&lang=js"
export * from "./GraduationApprovalsSection.vue?vue&type=script&lang=js"
import style0 from "./GraduationApprovalsSection.vue?vue&type=style&index=0&id=2f809f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f809f58",
  null
  
)

export default component.exports